import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const useAuth = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    const expiryTime = sessionStorage.getItem('expiryTime');

    if (!token || !expiryTime || Date.now() > expiryTime) {
      sessionStorage.clear();
      navigate('/'); 
    }
  }, [navigate]);

  return null;
};

export default useAuth;